import React from "react";
import CustomerPerformanceWidget from "./CustomerPerformanceWidget";

// "Non Tiered Customer Performance" widget — order-change events for ALL
// customers (not just tiered / "New" ones). Unlike the tiered widget, the
// backend tracks "change" reasons here — Customer Requested and AddOn — with a
// per-period "% of jobs with a change", so the count column reads "Jobs with
// Change". Thin wrapper over the shared CustomerPerformanceWidget; the backend
// returns the all-customers view behind the NonTieredCustomerPerformance
// endpoint. The drill-down (GetOrderChangeHistory) is not tier-filtered, so the
// shared /customer-performance/:reason route lines up exactly for this variant.
// const ROWS = [
//   { key: "customerRequested", label: "Customer Requested", slug: "customer-requested" },
//   { key: "addOns", label: "Add-Ons", slug: "AddOn" },
// ];
const ROWS = [
  { key: "uncoveredLabor", label: "Uncovered Labor", slug: "uncovered-labor" },
  { key: "uncoveredMaterialStockout", label: "Uncovered Material Stockout", slug: "uncovered-material-stockout" },
  { key: "qualities", label: "Qualities", slug: "qualities" },
  { key: "shortages", label: "Shortages", slug: "shortages" },
];
const NonTieredCustomerPerformance = (props) => (
  <CustomerPerformanceWidget
    {...props}
    endpoint="NonTieredCustomerPerformance"
    title="Non Tiered Customer Performance"
    rows={ROWS}
    countLabel="Jobs with Change"
  />
);

export default NonTieredCustomerPerformance;
